import geoHierarchyLevels from '../../geoHierarchyLevels.js';

const bigCities = ['Berlin', 'Hamburg'];

const getTitleFor = (hierarchyLevel, location, geoType) => {
  if (hierarchyLevel === geoHierarchyLevels.STREET) {
    return `Adressen in ${location}`;
  }
  if (hierarchyLevel === geoHierarchyLevels.DISTRICT) {
    return `Straßen in ${location}`;
  }
  if (hierarchyLevel === geoHierarchyLevels.CITY) {
    if (bigCities.includes(location)) {
      return `Größte Städte Deutschlands`;
    }
    if (geoType === geoHierarchyLevels.CITY) {
      return `Städte im selben Bundesland`;
    }
    return `Bezirke/Gemeinden in ${location}`;
  }
  if (hierarchyLevel === geoHierarchyLevels.REGION) {
    return `Landkreise in ${location}`;
  }

  return '';
};

const getLinkTextFor = (hierarchyLevel, geoType) => {
  if (hierarchyLevel === geoHierarchyLevels.STREET) {
    return `Weitere Adressen laden`;
  }
  if (hierarchyLevel === geoHierarchyLevels.DISTRICT) {
    return `Weitere Straßen laden`;
  }
  if (hierarchyLevel === geoHierarchyLevels.CITY) {
    if (geoType === geoHierarchyLevels.CITY) {
      return `Weitere Städte laden`;
    }
    return `Weitere Bezirke/Gemeinden laden`;
  }
  if (hierarchyLevel === geoHierarchyLevels.REGION) {
    return `Weitere Landkreise laden`;
  }

  return '';
};

export default {
  getTitleFor,
  getLinkTextFor,
};
